<template>
    <div v-if="visible" class="range-slider-wrapper">
        <h3 v-if="headline" class="range-slider__headline">{{ headline }}</h3>
        <div class="range-slider" :class="{
            'is-max': max == val,
            'is-min': min == val,
        }">
            <span class="range-slider__min">{{ min }} {{label}}</span>
            <vue-slider class="range-slider__component" ref="slider" v-model="val" v-bind="sliderOptions" :interval="1" :min="min" :max="max" @callback="$emit('change', $event)"></vue-slider>
            <span class="range-slider__max">{{ max }} {{label}}</span>
        </div>
    </div>
</template>

<script>

import vueSlider from 'vue-slider-component';

export default {
    name: 'RangeSlider',
    mounted() {
        // TODO: hotfix for slider not being slidable in the beginning
        setTimeout(() => this.visible = true, 0);
    },
    components: {
        vueSlider
    },
    computed: {},
    watch: {},
    props: {
        value: {
            type: Number,
            default: 5,
        },
        max: {
            type: Number,
            default: 10,
        },
        min: {
            type: Number,
            default: 1,
        },
        label: {
            type: String,
            default: '',
        },
        headline: {
            type: String,
            default: '',
        },
    },
    methods: {},
    data() {
        return {
            val: this.value,
            visible: false,
            sliderOptions: {
                eventType: 'auto',
                width: 'auto',
                height: 2,
                dotSize: 16,
                min: 0,
                max: 100,
                interval: 10,
                show: true,
                speed: 0.3,
                disabled: false,
                piecewise: false,
                usdKeyboard: false,
                enableCross: true,
                piecewiseLabel: false,
                tooltip: 'always',
                tooltipDir: 'top',
                reverse: false,
                clickable: true,
                realTime: false,
                lazy: false,
            },
        }
    }
}
</script>

<style lang="scss">

    @import '../scss/config';
    $faint-color: color(middleground);
    // $faint-color: faint-color(foreground, .8);
    // $faint-color: faint-color(foreground, 0);
    $min-max-bleed: 0;
    $label-top: -12;

    .range-slider {
        // width: 80%;
        // margin: 0 auto;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.is-min {
            .vue-slider-dot-handle {
                background: color(middleground) !important;
            }
            .vue-slider-tooltip {
                color: color(middleground) !important;
            }
        }

        &__component {
            width: 80% !important;
        }

        &__headline {
            @include font-regular();
            font-size: size(font-regular);
            line-height: 1;
            margin: 0;
            margin-bottom: size(large);
            margin-top: size(large);
        }

        &__min,
        &__max {
            // position: absolute;
            // top: rem($label-top); // magix number
            font-size: size(font-small);
            color: color(middleground);
        }

        &__min {
            // left: rem(-$min-max-bleed);
        }

        &__max {
            // right: rem(-$min-max-bleed);
        }
    }

    .vue-slider-component.vue-slider-horizontal {

        .vue-slider {

            // Specifcity on build
            :root & {
                $size: 30;
                $line-size: 2;
                background: none;
                height: rem($line-size) !important;
                margin-top: rem($size / 2 - $line-size);
                margin-bottom: rem($size / 2 - $line-size);

                &-dot-dragging {

                    .vue-slider-tooltip {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                &-tooltip {
                    background: none;
                    transform: translateY(-50%);
                    opacity: 0;
                    border: none;
                    font-size: size(font-small);
                    padding: 0;
                    line-height: 1;
                    color: color(accent);

                    &-top {
                        top: rem($label-top) !important;
                        // bottom: size(small) !important;
                    }

                    &:before,
                    &:after {
                        display: none,
                    }
                }

                &-piecewise {
                    background: $faint-color;
                }

                &-process {
                    background: color(accent);
                    border-radius: 0;
                }

                &-dot {

                    &-handle {
                        $size: 20;
                        position: absolute;
                        background: color(accent);
                        height: rem($size) !important;
                        width: rem($size) !important;
                        left: 50%;
                        top: 50%;
                        margin: 0;
                        margin-left: rem(-$size / 2);
                        margin-top: rem(-$size / 2);
                    }
                }

            }
        }

    }



</style>
